import { ru } from './ru';

export const jp: typeof ru = {
  BASE: {
    REQUIRED: '必須項目',
    CANCEL: 'キャンセル',
    REGISTRATION: '登録',
    BACK: '戻る',
    SUCCESS: '成功',
    ERROR: 'エラー',
  },
  LANGUAGE: {
    RU: 'ロシア語',
    EN: '英語',
    JP: '日本語',
  },
  FORM_LANGUAGES: {
    RUSSIAN: 'ロシア語',
    ENGLISH: '英語',
    JAPAN: '日本語',
  },
  AUTHORIZATION: {
    TITLE: 'ログイン',
    INPUT_LOGIN: 'ログインを入力してください',
    LOGIN: 'ログイン',
    INPUT_PASSWORD: 'パスワードを入力してください',
    PASSWORD: 'パスワード',
    SIGN_IN: 'ログイン',
    RESTORE_PASSWORD: 'パスワードを再設定',
  },
  RESTORE_PASSWORD: {
    TITLE: 'パスワードの再設定',
    INPUT_LOGIN: 'ログインを入力してください',
    LOGIN: 'ログイン',
    RESET: 'リセット',
    SUCCESS: '手順をメールで送信しました',
    SIGN_IN: 'ログイン',
    USER_NOT_FOUND: 'ユーザーが見つかりません',
  },
  CHANGE_PASSWORD: {
    TITLE: 'パスワードの変更',
    INPUT_NEW_PASSWORD: '新しいパスワードを入力してください！',
    INPUT_PASSWORD: 'パスワードを入力してください',
    REPEAT_PASSWORD: 'パスワードを再入力してください',
    PASSWORD_NOT_MATCH: 'パスワードが一致しません',
    CHANGE: '変更',
    SIGN_IN: 'ログイン',
    CHANGED: 'パスワードが変更されました',
  },
  PROFILE: {
    MAIN_LINK: 'ホーム',
    TITLE: 'プロフィール',
    NAME: '名前',
    EMAIL: 'メールアドレス',
    INCORRECT_EMAIL: 'メールアドレスが正しくありません',
    PHONE: '電話番号',
    TELEGRAM: 'Telegram',
    TELEGRAM_CONNECTED: '接続済み',
    CONNECT: '接続する',
    USER_UPDATE: 'プロフィールを編集',
    REQUIRED_FIELD: '必須項目',
    DEFAULT_LANGUAGE: 'デフォルト言語',
    UPDATE: '更新',
    CHANGE_PASSWORD: 'パスワードの変更',
    OLD_PASSWORD: '現在のパスワード',
    NEW_PASSWORD: '新しいパスワード',
    CONFIRM_PASSWORD: 'パスワードの確認',
    CONFIRM: 'よろしいですか？',
    LANGUAGE: '言語',
    CHANGE_PASSWORD_BTN: '変更',
    CHANGE_LANG_RUS: 'ロシア語',
    CHANGE_LANG_ENG: '英語',
    CHANGE_LANG_JPN: '日本語',
    CANCEL: 'キャンセル',
  },
  MUTATION: {
    ERROR: 'エラー',
    SUCCESS: '成功',
    PARTIAL: '一部完了',
  },
  LOGIN: {
    SEND_EMAIL: 'パスワード再設定用のリンクをメールで送信しました',
  },
  COUNTERPARTY_REGISTRATION: {
    FILL_FORM: 'フォームに記入する',
    ACCEPT_DOC: 'アカウントを作成することにより、',
    SUCCESS_REGISTRATION: '登録が完了しました',
    COMPANY_NAME: '会社名',
    POSTAL_CODE: '郵便番号',
    COMPANY_REGISTRATION_DATE: '会社設立日',
    COMPANY_REGISTRATION_NUMBER: '会社登録番号',
    COMPANY_INVOICE_NUMBER: '会社請求書番号',
    CONTACT_PERSON: '担当者',
    PHONE: '電話番号',
    FAX: 'ファックス',
    EMAIL: 'メールアドレス',
    COMMENT: 'コメント',
    LANGUAGE: '言語',
    ACCEPT: 'アカウントを登録する',
    BACK_TO_SITE: 'サイトに戻る',
    CUSTOMER: '顧客',
    SUPPLIER: 'サプライヤー',
    JAPAN_JURISDICTION: '日本法',
    INTERNATIONAL_JURISDICTION: '国際法',
    CHOOSE_COUNTRY: '国を選択',
    JAPAN_INDIVIDUAL_REGISTRATION: '個人',
    JAPAN_JURISTIC_PERSON_REGISTRATION: '法人',
    INTERNATIONAL_INDIVIDUAL_REGISTRATION: '個人',
    INTERNATIONAL_JURISTIC_PERSON_REGISTRATION: '法人',
    FULL_NAME: '氏名',
    COMPANY_ADDRESS: '会社の住所',
    IMPORT_COMMODITY: '主な輸入品目',
    CARS: '自動車',
    PARTS: '部品',
    COUNTERPARTY_TYPE: '協力形態を選択',
    COUNTERPARTY_SUPPLIER_FORM: 'サプライヤー登録フォーム',
    COUNTERPARTY_CUSTOMER_COUNTRY: '管轄国を選択',
    CHOOSE_ORGANIZATION_TYPE: '組織の種類を選択',
    FILL_COMPANY_FORM: '会社情報を入力してください',
    FILL_INDIVIDUAL_FORM: '個人情報を入力してください',
    REGISTERED_ADDRESS: '登録住所',
    ALREADY_HAVE_AN_ACCOUNT: 'すでにアカウントをお持ちですか？',
    LOGIN: 'ログイン',
    TERMS_OF_USE_AND_PRIVACY_POLICY: '利用規約 & プライバシーポリシー',
    DELETE_NOTE: 'アカウントを削除する場合は、この電子メールアドレスにお問い合わせください:',
    FULL_ADDRESS: '完全な住所',
    SAME_WITH_PHONE: '電話番号と同じ',
    ENGINE: 'エンジン',
  },
  NOTIFICATIONS: {
    UNNAMED_NOTIFICATION: '不明な通知',
    ENABLED: '有効',
    DISABLED: '無効',
    LOCKED: 'ロック',
    NOTIFICATIONS: '通知',
    NO_NOTIFICATIONS: '通知がありません',
  },
  TRANSACTIONS: {
    TITLE: '取引履歴',
    CREATED_AT: '日付',
    USER: '担当者',
    CHANGED_AMOUNT: '残高の変動',
    CURRENCY_RATE: '為替レート',
    MONEY_TYPE: '資金の種類',
    TYPE: '取引タイプ',
    AMOUNT_DIRTY: '取引通貨での金額',
    AMOUNT_CLEAR: '残高通貨での金額',
    AMOUNT: '金額',
    RATE: 'レート',
    CREATE_INCOME: '入金する',
    CREATE_TRANSFER: '別の残高へ振替',
    BALANCE_TRANSFER: '振替',
    BALANCE_INCOM: '入金',
    BOX_ISSUED: '仮払いとして支給',
    BOX_HANDED: 'オフィスへ返納',
    BANK_HANDED: '銀行へ預入',
    CURRENT_BALANCE: '現在の残高',
    CURRENCY: '通貨',
    BALANCE_INFO: '残高情報',
    CURRENT_COUNT: '現在の数量',
    COUNT_CHANGE: '数量の変動',
    TAX_STICKER_INFO: '納税ステッカー情報',
    TAX_STICKER: '納税ステッカー',
  },
  ACCOUNTABLE: {
    ACCOUNTABLE: '仮払い',
    NAME: '名前',
    ROLES: '役割',
    CASH_BALANCE: '残高',
    ADD_TAX_STICKER: '仮払いとして支給',
    REMOVE_TAX_STICKER: 'オフィスへ返納',
    TAX_STICKERS: '納税ステッカー',
    TAX_STICKER: '納税ステッカー',
    ADD_BANK: '現金を銀行へ預入',
    ADD_OFFICE: '現金をオフィスへ返納',
    ADD_SELF: '現金を仮払いとして支給',
    AMOUNT: '金額',
    VIEW_TRANSACTIONS: '取引履歴',
    BALANCES: '残高一覧',
    CASH: '現金',
    COUNT: '数量',
    ADD_EXPENSE: '経費として計上',
    TRANSFER_CASH: '別の残高へ振替',
    TO: '誰に振替する',
    SELECT_USER: 'ユーザーを選択',
    COMMENT: 'コメント',
  },
  CHATS_CENTER: {
    TITLE: 'チャットセンター',
    CREATE_CHAT: 'チャットを作成',
    CHAT_CREATION_FAILED: 'チャット作成に失敗しました',
    CHAT_CREATION_SUCCESSFULLY: 'チャット作成に成功しました',
    TOPIC: 'チャットのトピック',
    MESSAGE: 'メッセージ',
    FILES: 'ファイル',
    ADD_CHAT: 'チャットを作成',
    SELECT_PARTICIPANTS: '参加者を選択',
    PARTICIPANTS: '参加者',
    CHAT_PARTICIPANTS_ADDED_SUCCESSFULLY: '参加者が追加されました',
    CHAT_PARTICIPANTS_ADDED_FAILED: '参加者の追加に失敗しました',
    NO_CHATS: 'チャットが見つかりません',
    UNNAMED_CHAT: '名称未設定',
    NO_MESSAGES: 'メッセージはまだありません',
    EMPTY_MESSAGE: '空のメッセージ',
    YESTERDAY: '昨日',
    TWO_DAYS_AGO: '一昨日',
    CHAT: 'チャット',
    TYPE_MESSAGE: 'メッセージを入力...',
    SEND: '送信',
    ATTACH_FILES: 'ファイルを添付',
    ADD_PARTICIPANTS: '参加者を追加',
    REMOVE_PARTICIPANT: '参加者を削除',
    MESSAGE_SEND_FAILED: 'メッセージの送信に失敗しました',
    MESSAGES_LOAD_FAILED: 'メッセージの読み込みに失敗しました',
    MUTE: '通知を無効にする',
    UNMUTE: '通知を有効にする',
  },
};
